/* src/app/modules/shared/components/column/column-wrapper/column-wrapper.component.scss */
app-column-wrapper {
  display: contents;
}
/*# sourceMappingURL=column-wrapper.component.css.map */
